import * as React from 'react';

const VisibleIcon = () => (
    <svg width="12" height="8" viewBox="0 0 12 8" fill="none">
        <path
            d="M9.535 1.53461C7.58 -0.420391 4.415 -0.420391 2.465
        1.53461L0 3.99961L2.465 6.46461C4.42 8.41961 7.585 8.41961 9.535
        6.46461L12 3.99961L9.535 1.53461ZM6 5.99961C4.895 5.99961 4 5.10461
         4 3.99961C4 2.89461 4.895 1.99961 6 1.99961C7.105 1.99961 8 2.89461
          8 3.99961C8 5.10461 7.105 5.99961 6 5.99961Z"
        />
    </svg>
);

export default VisibleIcon;
